import React, { useEffect, useState } from "react";
import axios from "axios";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import CommandmentItem from "common/CommandmentItem/CommandmentItem";
import { routeConstants } from "navigation/routeConstants";
import { serviceConfig } from "configs";
import { ReactComponent as LangIcon } from "common/assets/flags/tk.svg";
import { ReactComponent as ThemeIcon } from "common/assets/icons/moon-stars.svg";
import { ReactComponent as NotificationIcon } from "common/assets/icons/bell.svg";
import { ReactComponent as AvatarIcon } from "common/assets/icons/user.svg";
import { P } from "common/P/P";

const breadcrumbItems = [
	{ label: "Buýruklar", path: routeConstants.root.route },
	{ label: "Buýruklar " },
];

const CommandmentsPage: React.FC = (): JSX.Element => {
	const [commandments, setCommandments] = useState<any>([]);
	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const currentUserId = user ? user?.user._id : ""; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);

	useEffect(() => {
		const fetchCommands = async () => {
			try {
				const response = await axios.get(
					`${serviceConfig.apiUrl}/user-commands/${currentUserId}`
				);
				setCommandments(response.data);
			} catch (error: any) {
				console.error("Error fetching commands:", error);
			}
		};

		fetchCommands();
	}, [currentUserId]);

	const handleUpdateCommand = async (
		commandId: string,
		sendingUserId: any,
		checked: boolean,
		files: string[]
	) => {
		try {
			const formData = new FormData();
			formData.append("commandId", commandId);
			formData.append("sendingUserId", sendingUserId._id);
			formData.append("checked", JSON.stringify(checked)); // Convert boolean to string
			files.forEach((file) => formData.append("files", file));

			await axios.put(`${serviceConfig.apiUrl}/command`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			setCommandments((prevCommands: any) =>
				prevCommands.map((cmd: any) =>
					cmd._id === commandId ? { ...cmd, checked } : cmd
				)
			);
			window.location.reload();
		} catch (error: any) {
			console.error(
				"Error updating command:",
				error.response ? error.response.data : error
			);
		}
	};

	return (
		<div className="grid grid-cols-1 gap-4">
			<div className="grid grid-cols-1 gap-4 px-6 py-3 place-items-end">
				{/* <LangIcon />
					<ThemeIcon />
					<div className="relative">
						<NotificationIcon />
						<div className="absolute top-[-5px] right-[-5px] grid px-[0.4rem] py-[0.1rem] rounded-full place-items-center place-content-center bg-redColor">
							<P size="t2" type="semibold" className="text-white">
								4
							</P>
						</div>
					</div> */}
				<div className="grid gap-3 grid-cols-maxTwo place-items-center">
					<div className="p-2 rounded-full bg-grayOne">
						<AvatarIcon />
					</div>
					<div className="grid">
						<P size="t1" type="medium">
							{user ? `${user.user.name.charAt(0)}.${user.user.sirname}` : ""}
						</P>
						<P size="t2" type="regular" className="text-grayTwo">
							{user ? user.user.userTypeId?.positionName : ""}
						</P>
					</div>
				</div>
			</div>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />
				<div className="grid gap-6 lg:grid-cols-maxFour TwoXl:grid-cols-maxFive">
					{commandments.map((item: any, idx: number) => (
						<CommandmentItem
							key={idx}
							name={item.commandName}
							note={item.note}
							from={`${item.sendingUserId.name.charAt(0)}. ${
								item.sendingUserId.sirname
							}`}
							position={item.sendingUserId.userTypeId.positionName}
							date={new Date(item.date)
								.toLocaleDateString("en-GB", {
									day: "2-digit",
									month: "2-digit",
									year: "numeric",
								})
								.replace(/\//g, ".")}
							files={item.files}
							checked={item.checked}
							onUpdate={() => {
								if (!item.checked) {
									handleUpdateCommand(
										item._id,
										item.sendingUserId || "",
										!item.checked,
										item.files
									);
								}
							}}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default CommandmentsPage;
